import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Form, FormGroup, Row, Col, Button } from 'reactstrap';
import { change, Field, reduxForm } from 'redux-form';
import PropTypes from 'prop-types';
import FormItem from '../../../common/forms/FormItem';
import { isRequired, validateEndDate } from '../../../../utils/validators';
import CustomerSelect from '../../../common/forms/select/CustomerSelect';
import DatePicker from '../../../common/forms/input/DatePicker';
import FormFooter from '../../../common/forms/FormFooter';
import BusinessSelect from '../../../common/forms/select/BusinessSelect';

const validateDate = (value, allValues) =>
  validateEndDate(value, allValues.fromDateString);

const LegalCargoForm = ({ handleSubmit, loading, dispatchChange }) => {
  const [searchByCompany, setSearchByCompany] = useState(false);

  const handleSearchChange = () => {
    setSearchByCompany(!searchByCompany);
    dispatchChange('legalCargoForm', 'customer', null);
    dispatchChange('legalCargoForm', 'business', null);
  };

  const renderCustomerSelect = searchByCompany ? (
    <FormGroup row>
      <FormItem label="Empresa" required>
        <Field
          name="business"
          component={BusinessSelect}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
  ) : (
    <FormGroup row>
      <FormItem label="Cliente" required>
        <Field
          name="customer"
          component={CustomerSelect}
          validate={[isRequired]}
        />
      </FormItem>
    </FormGroup>
  );

  return (
    <Form onSubmit={handleSubmit}>
      {renderCustomerSelect}
      <FormGroup row>
        <FormItem>
          <Button
            color="secondary"
            size="sm"
            className="mb-3"
            onClick={handleSearchChange}
          >
            {searchByCompany ? 'Buscar por Cliente' : 'Buscar por Empresa'}
          </Button>
        </FormItem>
      </FormGroup>

      <FormGroup row>
        <FormItem label="Desde" required>
          <Field
            name="fromDateString"
            component={DatePicker}
            validate={[isRequired]}
          />
        </FormItem>
      </FormGroup>
      <FormGroup row>
        <FormItem label="Hasta" required>
          <Field
            name="toDateString"
            component={DatePicker}
            validate={[isRequired, validateDate]}
          />
        </FormItem>
      </FormGroup>
      <Row>
        <Col className="flex row-reverse">
          <FormFooter
            saveButtonText="Buscar"
            saveButtonIcon="fa fa-search"
            saveButtonColor="primary"
            saveButtonDisabled={loading}
          />
        </Col>
      </Row>
    </Form>
  );
};

LegalCargoForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  dispatchChange: PropTypes.func.isRequired,
};

LegalCargoForm.defaultProps = {
  loading: false,
};

const mapDispatchToProps = {
  dispatchChange: change,
};

const form = reduxForm({
  form: 'legalCargoForm',
})(LegalCargoForm);

export default connect(null, mapDispatchToProps)(form);
